import { lazy } from "react";
import Protected from "../pages/auth/Protected";
import EventHistory from "../pages/Coach/Scheduler/EventHistory.jsx";
const AccountSetup = lazy(() => import("../pages/account-setup/AccountSetup"));
const ReservationHistory = lazy(() => import("../pages/calendar/ReservationHistory"));
const Calendar = lazy(() => import("../pages/calendar/Calendar.jsx"));
const EmailNotify = lazy(() => import("../pages/notification/EmailNotify.jsx"));
const AccountOnboardingUI = lazy(() => import("../pages/payout-management/AccountOnboardingUI .jsx"));
const PlanSetting = lazy(() => import("../pages/plan/PlanSetting.jsx"));
const AdvanceSettings = lazy(() => import("../pages/admin/advanced-setting/AdvanceSettings.jsx"));
const PlayerList = lazy(() => import("../pages/admin/member/PlayerList.jsx"));
const ClubProfile = lazy(() => import("../pages/admin/club/ClubProfile.jsx"));
const InviteStaff = lazy(() => import("../pages/admin/member/InviteStaff.jsx"));
const Privilege = lazy(() => import("../pages/Privileges/Privilege.jsx"));


export const ClubRoutes = [

    { path: "/calendar", element: <Protected Component={Calendar} /> },
    { path: "/calender-setup", element: <Protected Component={AdvanceSettings} /> },
    { path: "/players", element: <Protected Component={PlayerList} /> },
    {
        path: "/club-setup",
        element: <Protected Component={ClubProfile} />,
    },
    {
        path: "/access-management",
        element: <Protected Component={Privilege} />,
    },
    {
        path: "/invite-member",
        element: <Protected Component={InviteStaff} />,
    },
    {
        path: "/account-setup",
        element: <Protected Component={AccountSetup} />,
    },
    { path: "/plan-setup", element: <Protected Component={PlanSetting} /> },
    { path: "/email-notify", element: <Protected Component={EmailNotify} /> },
    {
        path: "/account", element: <Protected Component={AccountOnboardingUI} />,
    },
    {
        path: "/reservation-history",
        element: <Protected Component={ReservationHistory} />,
    },
    {
        path: "/event-history",
        element: <Protected Component={EventHistory} />,
    },
]